import React from 'react';
import styles from './MetadataPanel.module.css';

function fmt(v) { return v == null || v === '' ? '—' : String(v); }

export default function MetadataPanel({ study, parsed }) {
  const rows = [
    ['Study UID',       fmt(study?.study_instance_uid)],
    ['Modality',        fmt(study?.modality)],
    ['Body Part',       fmt(study?.body_part)],
    ['Study Date',      fmt(study?.study_date)],
    ['Accession #',     fmt(study?.accession_number)],
    ['Ordering MD',     fmt(study?.ordering_provider)],
    ['Location',        fmt(study?.location_name ? `${study.location_name} (${study.location_ae})` : study?.location_ae)],
    ['Images',          fmt(study?.num_images)],
    ['Patient',         fmt(study?.patient_name)],
    ['Patient ID',      fmt(study?.patient_id)],
    ['DOB',             fmt(study?.patient_dob)],
  ];
  const imgRows = parsed ? [
    ['Pixel',           `${parsed.cols || '?'} × ${parsed.rows || '?'}`],
    ['Bit Depth',       fmt(parsed.bitsAllocated)],
    ['Photometric',     fmt(parsed.photometricInterpretation)],
    ['Rescale',         parsed ? `${parsed.rescaleSlope}×v + ${parsed.rescaleIntercept}` : '—'],
  ] : [];

  return (
    <div className={styles.panel}>
      <div className={styles.section}>Study</div>
      <dl className={styles.list}>
        {rows.map(([k, v]) => (
          <React.Fragment key={k}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </React.Fragment>
        ))}
      </dl>
      {imgRows.length ? (
        <>
          <div className={styles.section}>Image</div>
          <dl className={styles.list}>
            {imgRows.map(([k, v]) => (
              <React.Fragment key={k}>
                <dt>{k}</dt>
                <dd>{v}</dd>
              </React.Fragment>
            ))}
          </dl>
        </>
      ) : null}
    </div>
  );
}
